import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { LocalStorageService } from '../providers/local-storage/local-storage.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(
        private localStorageService: LocalStorageService,
    ) { }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // Liste des URL pour lesquelles le token ne doit pas être ajouté
        const excludedUrls = [
            '/request-password-reset',
            '/reset-password',
            '/activate-account',
            '/resend-activation-email',
            '/login',
            '/token/refresh',
            '/register'
        ];

        // Vérifie si l'URL de la requête est dans la liste des URL exclues
        const isExcludedUrl = excludedUrls.some(url => request.url.includes(url));

        // Ajoute le token uniquement si l'URL n'est pas exclue et si l'utilisateur est connecté
        const authToken = this.localStorageService.getItem('authToken');
        if (authToken && !isExcludedUrl) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${authToken}`,
                },
            });
        }

        // Transmet la requête au prochain intercepteur ou au backend
        return next.handle(request);
    }
}